import { KK, VK } from '@/define/define'
import { MagnetSeniorType } from '@libs/types/enum'
import { LightModeParam, MacroParam, MacroType, MouseSetData, PostDynamicColor, SetMagnetKey } from '@libs/types/response'

export interface SocketConfig {
  IsWin10: boolean
  AstLanguage: string
  Is32Bit: boolean
  Version: string
}

export interface ResLayout {
  KeyMap: { [index: KK]: VK }
  KeyMapFire: { [index: KK]: number[] } //火力键 [0] 次数 [1] 间隔
  // KeyMedia: { [index: KK]: VK };
  // KeyMouse: { [index: KK]: VK };
  MacroType: { [index: KK]: MacroType }
  Macros: { [index: KK]: MacroParam[] }
  Magenet: { [index: KK]: SetMagnetSenior }
  KeyMapModifier: { [index: KK]: VK[] }
}

export interface DecorateLight {
  LightLastIsCustom: boolean
  LightMode: LightModeParam
  ColorsCustom: { [index: KK]: number }
  ColorsDynamic: PostDynamicColor
}

export interface LightModeSetting {
  Light: number
  Speed: number
}

export type LightModeSettingMap = { [mode: string]: LightModeSetting }

export interface ResSetData {
  LightMode: LightModeParam
  LightModeSettings?: LightModeSettingMap
  LightCustom: { [index: KK]: number }
  LightLastIsCustom: boolean
  Mouse: MouseSetData
  ColorsDynamic: PostDynamicColor
  Decorates: DecorateLight[]
  Layout: ResLayout
  LayoutFn: ResLayout
}

export interface SetMagnetSenior {
  KeyType: MagnetSeniorType
  Keys: SetMagnetKey[]
  MTDuration: number
  TGLMode: number
  KMEMode: [number, number]
  DelayTime: number
}

export interface IVersionInfo {
  ID: VersionSource
  UpdateInfo: string
  VersionName: string
}

export enum VersionSource {
  driver_service = 'driver_service',
}
